import React, { useId, useState } from 'react';
import { FiFileText, FiUsers, FiX, FiZap } from 'react-icons/fi';
import { useLanguage } from '../contexts/LanguageContext';
import './job-action-note.css';

export default function JobActionNote({ userId, onTailorCv, onOutreach }) {
  const { language } = useLanguage();
  const ar = language === 'ar';
  const titleId = useId();
  const storageKey = `jobseeqr:job-action-note:${userId || 'guest'}`;
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(storageKey) === 'dismissed'; }
    catch { return false; }
  });
  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try { sessionStorage.setItem(storageKey, 'dismissed'); }
    catch { /* The note remains dismissed while this workspace is open. */ }
  };

  return <aside className="opp-job-action-note" role="note" aria-labelledby={titleId} dir={ar ? 'rtl' : 'ltr'}>
    <div className="opp-job-action-note__heading">
      <FiZap aria-hidden="true" />
      <h2 id={titleId}>{ar ? 'حقّق المزيد مع JOBSEEQR' : 'Do more with JOBSEEQR'}</h2>
    </div>
    <button type="button" className="opp-job-action-note__close" onClick={dismiss} aria-label={ar ? 'إخفاء نصيحة JOBSEEQR' : 'Dismiss JOBSEEQR tip'}><FiX aria-hidden="true" /></button>
    <p>{ar ? 'خصّص سيرتك الذاتية لهذه الوظيفة، أو تعرّف على أشخاص في الشركة وابدأ محادثة معهم.' : 'Tailor your CV for this job, or find people at the company and start a conversation.'}</p>
    <div className="opp-job-action-note__actions">
      <button type="button" className="opp-button is-secondary" onClick={onTailorCv}><FiFileText aria-hidden="true" />{ar ? 'خصّص سيرتي الذاتية' : 'Tailor my CV'}</button>
      <button type="button" className="opp-button is-secondary" onClick={onOutreach}><FiUsers aria-hidden="true" />{ar ? 'تعرّف على أشخاص في الشركة' : 'Find people at the company'}</button>
    </div>
  </aside>;
}
